import styled from 'styled-components'

const SeoFooter = styled.div`
  padding: 30px 15px;

  @media (max-width: ${(props) => props.theme.screen_sm_max}) {
    display: none;
  }
  p {
    color: ${(props) => props.theme.tokens.color.monochrome.darker};
    line-height: normal;
    a {
      font-weight: 300 !important;
      color: ${(props) => props.theme.tokens.color.monochrome.darker} !important;
    }
  }
`

export default SeoFooter
